// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "SlideShow") {
    $this.SlideShow();
  }else if($this.data('section') == "SlideShow_2") {
    $this.SlideShow_2();
  }else if($this.data('section') == "Brand_Logo") {
    $this.Brand_Logo();
  }else if($this.data('section') == "Testimonial") {
    $this.Testimonial();
  }else if($this.data('section') == "Testimonial_Blog") {
    $this.Testimonial_Blog();
  }else if($this.data('section') == "Deal_Product") {
    $this.Deal_Product();
  }else if($this.data('section') == "Featured_Collection") {
    $this.Featured_Collection();
  }else if($this.data('section') == "list_Collection") {
    $this.list_Collection();
  }else if($this.data('section') == "Instagram") {
    $this.InstagramSection();
  }else if($this.data('section') == "CustomCollection") {
    $this.CustomCollection();
  }else if($this.data('section') == "related_product") {
    $this.related_product();
  }else if($this.data('section') == "Header_section") {
    $this.Header_section();
  }else if($this.data('section') == "single_product") {
    $this.single_product();
  }else{}   
}


// Slideshow active js
$.fn.SlideShow = function() {
	var intro11Slider = new Swiper('.intro11-slider', {
        loop: true,
        speed: 400,
		slidesPerView: 1,
        spaceBetween: 10,
		effect: 'fade',
        navigation: {
            nextEl: '.home1-slider-next',
            prevEl: '.home1-slider-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: 'true',
		},
	});
  
};

// Slideshow 2 active js
$.fn.SlideShow_2 = function() {
	var intro11Slider = new Swiper('.intro11-slider', {
        loop: true,
        speed: 400,
		slidesPerView: 1,
        spaceBetween: 10,
		effect: 'fade',
        navigation: {
            nextEl: '.home1-slider-next',
            prevEl: '.home1-slider-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: 'true',
		},
	});
  
};


// Brand Logo active js
$.fn.Brand_Logo = function() {
  
  	var swipContainer = this.find("[data-swiper-carousel]"),
       SliderlargeCol =  swipContainer.attr('data-lgcol'),
       SlidermdCol =  swipContainer.attr('data-mdcol'),
       SlidersmCol =  swipContainer.attr('data-smcol'),
       SliderxsCol =  swipContainer.attr('data-xscol') ;
  
	var intro11Slider = new Swiper('.brand-logo-carousel', {
		loop: true,
        speed: 800,
        spaceBetween: 10,
		effect: 'slide',
        navigation: {
            nextEl: '.home1-slider-next',
            prevEl: '.home1-slider-prev',
		},
		breakpoints: {
			320: {
			  slidesPerView: SliderxsCol,
			},
			480: {
			  slidesPerView: SlidersmCol,
			},
			768: {
                slidesPerView: SlidermdCol,
			},
			1200: {
				slidesPerView: SliderlargeCol,
			  },
		  }
	});
  
};


// Testimonial Carousel
$.fn.Testimonial = function() {
  
	var intro11Slider = new Swiper('.testimonial-carousel', {
        loop: true,
        speed: 800,
		slidesPerView: 1,
        spaceBetween: 10,
		effect: 'slide',
        navigation: {
            nextEl: '.home1-slider-next',
            prevEl: '.home1-slider-prev',
		},

	});

};


// Testimonial Carousel & Latest Post Carousel
$.fn.Testimonial_Blog = function() {
     
    // Testimonial Carousel
	var intro11Slider = new Swiper('.testimonial-carousel', {
        loop: true,
        speed: 800,
		slidesPerView: 1,
        spaceBetween: 10,
		effect: 'slide',
        navigation: {
            nextEl: '.home1-slider-next',
            prevEl: '.home1-slider-prev',
		},

	});
  
  
	// Latest Post Carousel
	var intro11Slider = new Swiper('.latest-post-carousel', {
        loop: true,
		direction: 'vertical',
		slidesPerView: 3,
		mousewheel: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

	});

};


	// item Carousel 2 & Countdown
$.fn.Deal_Product = function() {
  
  	var swipContainer = this.find("[data-swiper-carousel]"),
       SliderlargeCol =  swipContainer.attr('data-lgcol'),
       SlidermdCol =  swipContainer.attr('data-mdcol'),
       SlidersmCol =  swipContainer.attr('data-smcol'),
       SliderxsCol =  swipContainer.attr('data-xscol') ;
  
  // item Carousel 2
	var intro11Slider = new Swiper('.item-carousel-2', {
		autoHeight: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: 'true',
		},
		//autoplay: {},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
			  slidesPerView: SliderxsCol,
			},
			// when window width is >= 480px
			480: {
			  slidesPerView: SlidersmCol,
			},
			// when window width is >= 767px
			768: {
			  slidesPerView: SlidermdCol,
			},
			// when window width is >= 1200px
			1200: {
				slidesPerView: SliderlargeCol,
			  },
		  }
	});
  
  
  	/*----------------------------------------*/
	/*  Countdown
	/*----------------------------------------*/
	$('[data-countdown]').each(function() {
		var $this = $(this), finalDate = $(this).data('countdown');
		$this.countdown(finalDate, function(event) {
			$this.html(event.strftime('<div class="single-countdown"><span class="single-countdown_time">%D</span><span class="single-countdown_text">Days</span></div><div class="single-countdown"><span class="single-countdown_time">%H</span><span class="single-countdown_text">Hours</span></div><div class="single-countdown"><span class="single-countdown_time">%M</span><span class="single-countdown_text">Min</span></div><div class="single-countdown"><span class="single-countdown_time">%S</span><span class="single-countdown_text">Sec</span></div>'));
		});
	});

};


// Product Carousel
$.fn.Featured_Collection = function() {
  
  	var swipContainer = this.find("[data-swiper-carousel]"),
       SliderlargeCol =  swipContainer.attr('data-lgcol'),
       SlidermdCol =  swipContainer.attr('data-mdcol'),
       SlidersmCol =  swipContainer.attr('data-smcol'),
       SliderxsCol =  swipContainer.attr('data-xscol'),
       SliderperCol =  swipContainer.attr('data-percol') ;
  
    //console.log(SliderlargeCol);
  
	var intro11Slider = new Swiper('.product-slider', {
      slidesPerColumnFill: 'row',
        slidesPerColumn: SliderperCol,
		spaceBetween: 10,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: 'true',
		},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
			  slidesPerView: SliderxsCol,
			  spaceBetween: 10
			},
			// when window width is >= 480px
			480: {
			  slidesPerView: SlidersmCol,
			  spaceBetween: 10
			},
			// when window width is >= 767px
			768: {
			  slidesPerView: SlidermdCol,
			  spaceBetween: 10
			},
			// when window width is >= 1200px
			1200: {
				slidesPerView: SliderlargeCol,
				spaceBetween: 10
			  },
		  }
	});
  

};


// Product Carousel
$.fn.list_Collection = function() {
  
  	var swipContainer = this.find("[data-swiper-carousel]"),
       SliderlargeCol =  swipContainer.attr('data-lgcol'),
       SlidermdCol =  swipContainer.attr('data-mdcol'),
       SlidersmCol =  swipContainer.attr('data-smcol'),
       SliderxsCol =  swipContainer.attr('data-xscol') ;
  
    //console.log(SliderlargeCol);
	var intro11Slider = new Swiper('.product-slider', {
		spaceBetween: 10,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: 'true',
		},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
			  slidesPerView: SliderxsCol,
			  spaceBetween: 10
			},
			// when window width is >= 480px
			480: {
			  slidesPerView: SlidersmCol,
			  spaceBetween: 10
			},
			// when window width is >= 767px
			768: {
			  slidesPerView: SlidermdCol,
			  spaceBetween: 10
			},
			// when window width is >= 1200px
			1200: {
				slidesPerView: SliderlargeCol,
				spaceBetween: 10
			  },
		  }
	});
  

};

    // Instgram active js
    $.fn.InstagramSection = function(){
      var activation = this.find('[data-username]'),
          activeId = activation.attr('id'),
          clientUsername = activation.attr('data-username'),
          instagramHastag = activation.attr('data-hashtag'),
          ItemsLimit = activation.attr('data-limit'),
          imageSize = activation.attr('data-size'),
          instaslider = ".instagram-carousel";

      $.instagramFeed({
        'tag': instagramHastag,
        'username': clientUsername,
        'container': "#"+activeId,
        'display_profile': false,
        'display_biography': false,
        'display_gallery': true,
        'styling': false,
        'items': ItemsLimit,
        'margin': 1,
        'image_size': imageSize
      });

 
    };



// Product Carousel
$.fn.CustomCollection = function() {
  
  	var swipContainer = this.find("[data-swiper-carousel]"),
       SliderlargeCol =  swipContainer.attr('data-lgcol'),
       SlidermdCol =  swipContainer.attr('data-mdcol'),
       SlidersmCol =  swipContainer.attr('data-smcol'),
       SliderxsCol =  swipContainer.attr('data-xscol') ;
  
    //console.log(SliderlargeCol);
  
	var intro11Slider = new Swiper('.product-slider', {
		spaceBetween: 10,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: 'true',
		},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
			  slidesPerView: SliderxsCol,
			  spaceBetween: 10
			},
			// when window width is >= 480px
			480: {
			  slidesPerView: SlidersmCol,
			  spaceBetween: 10
			},
			// when window width is >= 767px
			768: {
			  slidesPerView: SlidermdCol,
			  spaceBetween: 10
			},
			// when window width is >= 1200px
			1200: {
				slidesPerView: SliderlargeCol,
				spaceBetween: 10
			  },
		  }
	});
  

};


// Product Carousel
$.fn.related_product = function() {
  
  	var swipContainer = this.find("[data-swiper-carousel]"),
       SliderlargeCol =  swipContainer.attr('data-lgcol'),
       SlidermdCol =  swipContainer.attr('data-mdcol'),
       SlidersmCol =  swipContainer.attr('data-smcol'),
       SliderxsCol =  swipContainer.attr('data-xscol') ;
  
    //console.log(SliderlargeCol);
  
	var intro11Slider = new Swiper('.product-slider', {
		spaceBetween: 10,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: 'true',
		},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
			  slidesPerView: SliderxsCol,
			  spaceBetween: 10
			},
			// when window width is >= 480px
			480: {
			  slidesPerView: SlidersmCol,
			  spaceBetween: 10
			},
			// when window width is >= 767px
			768: {
			  slidesPerView: SlidermdCol,
			  spaceBetween: 10
			},
			// when window width is >= 1200px
			1200: {
				slidesPerView: SliderlargeCol,
				spaceBetween: 10
			  },
		  }
	});
  

};



$.fn.Header_section = function() {
  

  /*----------------------------------------
	   Sticky Menu Activation
	---------------------------------*/
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 300) {
			$('.header-sticky').addClass('sticky');
		} else {
			$('.header-sticky').removeClass('sticky');
		}
	});
  
  
  
  
  };


// Product Carousel
$.fn.single_product = function() {
  
    	var swipContainer = this.find("[data-swiper-carousel]"),
       SliderlargeCol =  swipContainer.attr('data-lgcol'),
       SlidermdCol =  swipContainer.attr('data-mdcol'),
       SlidersmCol =  swipContainer.attr('data-smcol'),
       SliderxsCol =  swipContainer.attr('data-xscol') ;
  
    	var intro11Slider = new Swiper('.single-product-thumb', {
		spaceBetween: 10,
 		loop: true,
        navigation: {
            nextEl: '.single-product-thumb .swiper-button-next',
            prevEl: '.single-product-thumb .swiper-button-prev',
		},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
			  slidesPerView: SliderxsCol,
			  spaceBetween: 10
			},
			// when window width is >= 480px
			480: {
			  slidesPerView: SlidersmCol,
			  spaceBetween: 10
			},
			// when window width is >= 767px
			768: {
			  slidesPerView: SlidermdCol,
			  spaceBetween: 10
			},
			// when window width is >= 1200px
			1200: {
				slidesPerView: SliderlargeCol,
				spaceBetween: 10
			  },
		  }
	});
  
    
      // prodct details slider active
  $('.product-large-slider').slick({
    fade: true,
    arrows: false,asNavFor: '.pro-nav'
  });
  // product details slider nav active
  $('.pro-nav').slick({
    slidesToShow: 4,
    asNavFor: '.product-large-slider',
    speed: 1000,
    centerPadding: 0,
    focusOnSelect: true,prevArrow: '<button type="button" class="slick-prev"><i class="lnr lnr-arrow-right"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="lnr lnr-arrow-left"></i></button>',});
  $("img.lazyload").lazyload();

};




(function($) {
  "use strict";

  jQuery(document).ready(function(){


    // All jQuery activation code paste here

	/*----------------------------------------
		Off Canvas
	-------------------------------------------*/
	$(".off-canvas-btn").on('click', function () {
		$("body").addClass('fix');
		$(".off-canvas-wrapper").addClass('open');
	});

	$(".btn-close-off-canvas,.off-canvas-overlay").on('click', function () {
		$("body").removeClass('fix');
		$(".off-canvas-wrapper").removeClass('open');
	});

	/*----------------------------------------
		Off Canvas Menu
	-------------------------------------------*/
	$(".off-canvas-menu-btn").on('click', function () {
		$("body").addClass('fix');
		$(".off-canvas-menu-wrapper").addClass('open');
	});

	$(".btn-close-off-canvas,.off-canvas-overlay").on('click', function () {
		$("body").removeClass('fix');
		$(".off-canvas-menu-wrapper").removeClass('open');
	});

	/*----------------------------------------
		Responsive Mobile Menu
	------------------------------------------*/
	//Variables
	var $offCanvasNav = $('.mobile-menu'),
	$offCanvasNavSubMenu = $offCanvasNav.find('.dropdown');
	//Add Toggle Button With Off Canvas Sub Menu
	$offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i></i></span>');
	//Close Off Canvas Sub Menu
	$offCanvasNavSubMenu.slideUp();
	//Category Sub Menu Toggle
	$offCanvasNav.on('click', 'li a, li .menu-expand', function(e) {
	var $this = $(this);
	if ( ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
		e.preventDefault();
		if ($this.siblings('ul:visible').length){
			$this.parent('li').removeClass('active');
			$this.siblings('ul').slideUp();
		} else {
			$this.parent('li').addClass('active');
			$this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
			$this.closest('li').siblings('li').find('ul:visible').slideUp();
			$this.siblings('ul').slideDown();
		}
	}
	});
    
    
    
	/*----------------------------------------*/
	/*  Shop Grid Activation
	/*----------------------------------------*/
	$('.shop_toolbar_btn > button').on('click', function (e) {
	
		e.preventDefault();
		
		$('.shop_toolbar_btn > button').removeClass('active');
		$(this).addClass('active');
		
		var parentsDiv = $('.shop_wrapper');
		var viewMode = $(this).data('role');
		
		
		parentsDiv.removeClass('grid_3 grid_4 grid_5 grid_list').addClass(viewMode);

		if(viewMode == 'grid_3'){
			parentsDiv.children().addClass('col-lg-4 col-md-6 col-sm-6').removeClass('col-lg-3 col-cust-5 col-12');
			
		}

		if(viewMode == 'grid_4'){
			parentsDiv.children().addClass('col-lg-3 col-md-6 col-sm-6').removeClass('col-lg-4 col-cust-5 col-12');
		}
		
		if(viewMode == 'grid_list'){
			parentsDiv.children().addClass('col-12').removeClass('col-lg-3 col-lg-4 col-md-6 col-sm-4 col-sm-6 col-cust-5');
		}
			
	});
    
	
	/*----------------------------------------*/
	/*  Countdown
	/*----------------------------------------*/
	$('[data-countdown]').each(function() {
		var $this = $(this), finalDate = $(this).data('countdown');
		$this.countdown(finalDate, function(event) {
			$this.html(event.strftime('<div class="single-countdown"><span class="single-countdown_time">%D</span><span class="single-countdown_text">Days</span></div><div class="single-countdown"><span class="single-countdown_time">%H</span><span class="single-countdown_text">Hours</span></div><div class="single-countdown"><span class="single-countdown_time">%M</span><span class="single-countdown_text">Min</span></div><div class="single-countdown"><span class="single-countdown_time">%S</span><span class="single-countdown_text">Sec</span></div>'));
		});
	});
    
	/*--------------------------------
	/* 	Scroll To Top
	-------------------------------- */
	function scrollToTop() {
		var $scrollUp = $('.scroll-to-top'),
			$lastScrollTop = 0,
			$window = $(window);

		$window.on('scroll', function () {
			var topPos = $(this).scrollTop();
			if (topPos > $lastScrollTop) {
				$scrollUp.removeClass('show');
			} else {
				if ($window.scrollTop() > 200) {
					$scrollUp.addClass('show');
				} else {
					$scrollUp.removeClass('show');
				}
			}
			$lastScrollTop = topPos;
		});

		$scrollUp.on('click', function (evt) {
			$('html, body').animate({
				scrollTop: 0
			}, 600);
			evt.preventDefault();
		});
	}
	scrollToTop();

    
    
    // Product grid color variant activation code. 
    
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });
    

  });
  
})(jQuery);
